import * as yup from 'yup';

export const auditorialogSchema = yup.object({

});